export interface Recommendation {
  recordId: string;
  title: string;
  author: string;
  description: string;
  coverImageUrl: string;
  resourceTypes: string[];
  specialFormat: string;
}

export enum RecommendationType {
  ALSO_VIEWED = 'OTHER_USERS_ALSO_VIEWED',
  ALSO_CHECKED_OUT = 'OTHER_USERS_ALSO_BOUGHT',
  RELATED_ITEMS = 'RELATED_ITEMS',
}
